import React from "react";
import { IconProps } from "./types";

function IconAutoCloseCircle(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="#EE3763"
      />
      <path
        d="M12.1491 17.9384C15.3972 17.9384 18.0302 15.3054 18.0302 12.0573C18.0302 8.80932 15.3972 6.17627 12.1491 6.17627C8.90111 6.17627 6.26807 8.80932 6.26807 12.0573C6.26807 15.3054 8.90111 17.9384 12.1491 17.9384Z"
        stroke="white"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0898 17.5298L16.2661 19.0001"
        stroke="white"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <path
        d="M9.2085 17.5298L8.03228 19.0001"
        stroke="white"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <path
        d="M12.1494 8.52881V12.0575L14.5018 13.2337"
        stroke="white"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.68018 7.64648C5.68018 7.64648 6.85639 5.88216 8.91477 5"
        stroke="white"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <path
        d="M18.3242 7.64648C18.3242 7.64648 17.148 5.88216 15.0896 5"
        stroke="white"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <path
        d="M12.1494 5.7002V6.0002"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default IconAutoCloseCircle;
